module.exports = __webpack_public_path__ + "img/appAsset--webhooks-ax.81b0a2ba.svg";